import { PRODUCT_CARD_CLICKED, CLICK, PRODUCT_ADD_TO_CART, PRODUCT_ADD_TO_WISHLIST, PRODUCT_REMOVE_FROM_WISHLIST, PRODUCT_SELECT_SHADE, PRODUCT_SELECT_SIZE, PRODUCT_EVENT_IMPRESSIONS, PRODUCT_NOTIFY_ME, } from '../constants';
export const getTrackingProductTags = (tags) => {
    let productTags = [];
    try {
        for (let index = 0; index < tags.length; index++) {
            const currentTag = tags[index];
            productTags.push(currentTag.title || currentTag);
        }
    }
    catch (error) {
        productTags = [];
    }
    return productTags;
};
export const getCommonProductData = (clickedProduct, additionalProductParams = {}) => {
    var _a;
    // get listing Data Activation data flag from the array(default -> false)
    const isListingDataRequired = (additionalProductParams === null || additionalProductParams === void 0 ? void 0 : additionalProductParams.isListingDataRequired) || false;
    const listingData = {
        listing_position: additionalProductParams === null || additionalProductParams === void 0 ? void 0 : additionalProductParams.listingPosition,
        listing_identifier: additionalProductParams === null || additionalProductParams === void 0 ? void 0 : additionalProductParams.listingIdentifier,
    };
    // get product position from additional params
    const productPosition = additionalProductParams === null || additionalProductParams === void 0 ? void 0 : additionalProductParams.productPosition;
    const isProductPositionPresent = !!(typeof productPosition === 'number');
    const pageURL = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href : '';
    // finally returning it with the required data
    return (Object.assign(Object.assign({ product_id: (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.childId) || (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.id), product_sku: clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.sku, product_name: clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.name, product_brand: clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.brandName, product_mrp: clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.mrp, product_price: (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.offerPrice) || (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.price), product_dp: (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.offerPrice) || (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.price), product_tags: getTrackingProductTags((clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.newTags) || (clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.dynamicTags) || []), product_inventory: clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.quantity, tracking_metadata: clickedProduct === null || clickedProduct === void 0 ? void 0 : clickedProduct.tracking_metadata, page_url: pageURL }, (!!isListingDataRequired && listingData)), (!!isProductPositionPresent && { product_position: productPosition })));
};
export const generateProductImpressionData = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    const trackingData = Object.assign(Object.assign({ event: PRODUCT_EVENT_IMPRESSIONS }, getCommonProductData(product, additionalProductParams)), { hit_recorded_at: new Date().getTime() / 1000 });
    return trackingData;
};
export const generateProductClickedData = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_CARD_CLICKED }, getCommonProductData(product, additionalProductParams));
};
export const generateProductAddToCartData = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_ADD_TO_CART }, getCommonProductData(product, additionalProductParams));
};
export const generateProductAddToWishlistData = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_ADD_TO_WISHLIST }, getCommonProductData(product, additionalProductParams));
};
export const generateProductRemoveFromWishlistData = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_REMOVE_FROM_WISHLIST }, getCommonProductData(product, additionalProductParams));
};
export const generateProductSelectShade = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_SELECT_SHADE }, getCommonProductData(product, additionalProductParams));
};
export const generateProductSelectSize = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_SELECT_SIZE }, getCommonProductData(product, additionalProductParams));
};
export const generateProductNotifyMe = (productImpressionParams) => {
    const { product, additionalProductParams } = productImpressionParams;
    return Object.assign({ event_type: CLICK, event_name: PRODUCT_NOTIFY_ME }, getCommonProductData(product, additionalProductParams));
};
export const logCustomError = (logger, analyticsLoggingEnabled, analyticsLoggingSampleRate, actualError, customMessage) => {
    if (!analyticsLoggingEnabled) {
        return;
    }
    /*
      Generating random number and checking if sample rate lies within it then proceed for logging,
      otherwise return
    */
    const randomSample = Math.random();
    // check
    const isSampleWithinRange = !!(analyticsLoggingSampleRate > 0 && analyticsLoggingSampleRate >= randomSample);
    if (isSampleWithinRange) {
        logger.error(actualError, customMessage);
    }
};
export const logCustomRetinaError = (loggerFn, analyticsLoggingEnabled, analyticsLoggingSampleRate, actualError, customMessage) => {
    if (!analyticsLoggingEnabled) {
        return;
    }
    /*
      Generating random number and checking if sample rate lies within it then proceed for logging,
      otherwise return
    */
    const randomSample = Math.random();
    const isSampleWithinRange = !!(analyticsLoggingSampleRate > 0 && analyticsLoggingSampleRate >= randomSample);
    if (isSampleWithinRange) {
        // call logging callback from client, as per the client syntax
        loggerFn(actualError, customMessage);
    }
};
